import * as React from 'react'
import { IRTIS3_CACHE_OFFSET_KEY } from '../utils/cache.utils'

const ServerTimeContext = React.createContext<{
  updateServerTime: (serverTime: number) => void
  getCalibratedDateTime: () => Date
}>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateServerTime: () => {},
  getCalibratedDateTime: () => new Date(),
})

function readOffsetFromLocalStorage() {
  try {
    const entry = localStorage.getItem(IRTIS3_CACHE_OFFSET_KEY)
    const offset = entry ? parseInt(entry, 10) : 0
    return isNaN(offset) ? 0 : offset
  } catch (error) {
    return 0
  }
}

type DateTimeProps = {
  children: React.ReactNode
}
const ServerTimeProvider: React.FC<DateTimeProps> = ({ children }) => {
  const [offset, setOffset] = React.useState<number>(
    readOffsetFromLocalStorage(),
  )

  const updateServerTime = (newServerTime = 0) => {
    const newTime = Date.now() - newServerTime
    setOffset(newTime)
    localStorage.setItem(IRTIS3_CACHE_OFFSET_KEY, newTime.toString())
  }

  /**
   * We need to calibrate current dateTime to ensure the correct time is used.
   * The halteborden computer-time is not always 100% accurate.
   * Using serverTijd we can get the difference/offset and use this to dipslay a more accurate dateTime.
   */
  const getCalibratedDateTime = () => {
    return new Date(Date.now() - offset)
  }

  return (
    <ServerTimeContext.Provider
      value={{ updateServerTime, getCalibratedDateTime }}
    >
      {children}
    </ServerTimeContext.Provider>
  )
}

export { ServerTimeProvider, ServerTimeContext }
